<template>
  <div v-if="data.value" class="flex items-center lg:justify-end">
    <i v-if="data.warn" class="md-18 text-warning mr-25">warning</i>
    {{ data.value }}
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => {},
    },
  },
};
</script>
